import { AuthSelectors, ObFlowService, useTranslation } from '@web_opxp/features';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as HistoryService from './historyService';

export default function useRedirect() {
  const sessionToken = useSelector(AuthSelectors.getToken);
  const { language } = useTranslation();
  const location = useLocation();
  // this redirect must also support ob_flow in case flow is active
  const redirectToTraining = useCallback(() => {
    const isOnSubscribePage = HistoryService.isSubscribe(location);
    const obFlowActive = HistoryService.isCustomObFlowActive(location);
    if (isOnSubscribePage && obFlowActive) {
      return ObFlowService.redirectToNextObStep('subscribe', language, sessionToken);
    }
    return HistoryService.redirectToTraining(language, sessionToken);
  }, [language, location, sessionToken]);
  return { redirectToTraining };
}
